export default {
  auto: '*',
}
